// 发布前更新此标识，用于确认钉钉实际加载的前端版本。
// 页面显示版本的统一入口，发布时与实际部署包版本保持一致。
export const APP_VERSION = '2026.09.18.3';
